// @flow

export type MockNodeAttributes = {|
  id: string,
  state?: string,
  icon?: string,
  handles?: Array<string>,
  x?: number,
  y?: number,
|};

export type MockNode = {|
  name: 'node',
  attributes: MockNodeAttributes,
  children: Array<any> | string,
|};

export const mockNode = (
  attributes: MockNodeAttributes,
  children: string | Array<any>,
): MockNode => {
  const {id, state, icon, handles} = attributes;
  return {
    name: 'node',
    attributes: {id, state, icon, handles, x: 0, y: 0},
    children,
  };
};
